import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { OrderHistory } from '../../Models/Domains/Transactions/Investments/OrderHistory';

declare var IS_RUNNING_IN_APP_POOL;

export class OrderHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(orderId: number): Promise<Array<OrderHistory>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/OrderHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { orderId: orderId }

    return AjaxWrapper.get<Array<OrderHistory>, any>(url, data);
  }
}

